import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * 活动页等场景使用 GSAP ScrollTrigger（与 Ingamana 等项目条的 scrub 动效一致）。
 * 仅客户端执行；组件内通过 useNuxtApp().$gsap / $scrollTrigger 访问。
 */
export default defineNuxtPlugin(() => {
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.config({
    autoRefreshEvents: 'visibilitychange,DOMContentLoaded,load,resize',
  });

  return {
    provide: {
      gsap,
      scrollTrigger: ScrollTrigger,
    },
  };
});
